export default __webpack_public_path__ + "images/models/d34a521a23657045e8704711d1ef715e.glb";